<template>
  <div class="as-map-area">
      <div id="map"></div>
  </div>
</template>

<script>
import FoodMap from '@/lib/map'
export default {
  name: 'Map',
  props: ['districtId'],
  data () {
    return {
      laGeoJSON: this.$store.state.laData,
      laCGeoJSON: this.$store.state.laCData,
      comGeoJSON: this.$store.state.comData,
      filters: this.$store.state.filters,
      districtTable: this.$store.state.districtTable,
      districtUdi: ''
    }
  },
  async mounted () {
    global.foodMap = new FoodMap(this.$i18n.locale, this.$t('message'))
    const baseUrl = window.location.protocol + '//' + window.location.host + '/'
    global.foodMap.initCartoLayer('district', this.laGeoJSON, `
      color: rgba(0,0,0,0)
      strokeColor: black
      strokeWidth: 0.5
        `)
    // // Initialize and mount a layer
    global.foodMap.initCartoLayer('community', this.comGeoJSON, `
      @name: $name
      @caten: $categoryen
      @catfr: $categoryfr
      @sscaten: $subcategoryen
      @sscatfr: $subcategoryfr
      @typefr: $typefr
      @typeen: $typeen
      @address: $address
      @district: $district
      @phone: $téléphone
      @heures: $heuresdouverture
      @hours: $openinghoursen
      @web: $web
      @path: $categoryPath
      symbol: ramp(
        buckets(
          @sscatfr,
          ['Dépannage alimentaire et aide alimentaire',
          'Éducation populaire en sécurité alimentaire',
          'Jardins',
          'Marchés fermiers',
          'Points de chute aliments frais'
          ]),
        [
          image('${baseUrl}icons/svgs/solid/heart-rw4.svg'),
          image('${baseUrl}icons/svgs/solid/people-carry-rw5.svg'),
          image('${baseUrl}icons/svgs/solid/seedling-rw4.svg'),
          image('${baseUrl}icons/svgs/solid/tractor-rw4.svg'),
          image('${baseUrl}icons/svgs/solid/truck-loading-rw4.svg'),
        ]
      )
      symbolPlacement: placement(0,-0.10)
      width: zoom()*1.5
      filter: ramp(zoomrange([12.25,12.75]),[false,true])
    `)
    global.foodMap.initCartoLayer('districtCentroids', this.laCGeoJSON, `
      @v_features: viewportFeatures($qty)
      width: 33
      strokeWidth: 3
      strokeColor: #F9BE02
      color: opacity(#02D56B,0.8)
      filter: ramp(zoomrange([11.75,12.25]),[true,false])
    `)
    // Initialize this layers popup interactivity for community Layer
    global.foodMap.layerPopup('community')
    // Initialize this layers popup interactivity for community Layer
    global.foodMap.layerPopup('districtCentroids')
    global.foodMap.initCartoLayer(`commercial`, this.$store.state.fsData, `
        @name: $name
        @caten: $categoryen
        @catfr: $categoryfr
        @sscaten: $subcategoryen
        @sscatfr: $subcategoryfr
        @typefr: $typefr
        @typeen: $typeen
        @address: $address
        @district: $district
        @phone: $téléphone
        @heures: $heuresdouverture
        @hours: $heuresdouverture
        @web: $web
        @path: $categoryPath
        width: zoom()/2.5
        strokeWidth: 0.25
        color: #F9BE02
        filter: ramp(zoomrange([13.25,13.25]),[false,true])
        `)
    global.foodMap.layerPopup('commercial')
    global.foodMap.setMapCenter(this.laGeoJSON, `CODEID`, this.getDistrictId(this.districtId))
  },
  methods: {
    getDistrictId (id) {
      this.districtTable.forEach((obj) => {
        if (!obj.SiteId || !id) {
          return '0'
        } else {
          if (id.toString() === obj.SiteId.toString()) {
            this.districtUdi = obj.TrueId.toString()
          }
        }
      })
      return this.districtUdi
    }
  }
}
</script>
<style>
#map {
  position: relative;
    display: flex;
    height: 100vh;
    width: 100%;
    z-index: 0;
}

 .mapboxgl-popup-content{
   background: unset !important;
   padding: 0 !important;
   box-shadow: unset !important;
   width: 300px;
   max-width: 300px !important;
 }

.mapboxgl-popup-anchor-bottom{
    max-width: 300px !important;
}
 .mapboxgl-popup-tip{
   color: transparent !important;
   border-top-color: transparent !important;
 }

 .as-tooltip{
   padding: 8px 8px !important;
   font-size: 18px;
   font-weight: 600;
   /* text-shadow: 1px 1px black; */
   --as--tooltip--error--background-color: #F53240 !important;
   --as--tooltip--secondary--background-color: #F9BE02 !important;
   --as--tooltip--primary--background-color: #3984CE !important;
   --as--tooltip--success--background-color: #02D56B !important;

 }

 .as-subheader{
    border-radius: 5px !important;
 }
.whiteText{
   color: white !important;
 }
.error{
  background-color: #F53240 !important;
}
.success{
  background-color: #02D56B !important;
}
.secondary{
  background-color: #F9BE02 !important;
}
.primary{
  background-color: #3984CE !important;
}

.values{
  padding-left: 10px;
  display: inline-flex;
}

.label{
  display: flex;
  padding: 5px;
}

</style>
